import PageTitle from './template_01';

const DefaultPageTitle=(props) =>{
    return (
        <PageTitle {...props}/>
    );
  }
  
  export default DefaultPageTitle;